import React from "react";
import { useDispatch } from 'react-redux';
import {
  setAPI,
  setUser, /*setUserParameter,*/
  setConnect, setRequestError, setFirstLog,
  setDragPlayer,
  setSubscription,
  setProPlus,
  addFreemiumTracksLoad,
  setSplashState,
  addToast
} from "../actions/index";

import {
  broadcastAudioPM,
  setOutsiderPM
} from "../components/library/partymode/redux/actions/index";

import * as Config from '../config';
const axios = require('axios');
const querystring = require('querystring');

// Store API LINK Management
const useStoreApi = () => {
  const dispatch = useDispatch();

  const prepareStore = (token) => {
    // console.log('PREPARE STORE', token)

    const setToken = (newToken) => { 
      token = newToken;
      (window['YouDJ'] && window['YouDJ'].set_reporting_token) && window['YouDJ'].set_reporting_token(token.access_token);
    }

    const getHeaders = () => {
      return { headers: { 'Authorization': `Bearer ${token.access_token}` }};
    }
  
    let headersReporting = { headers: { 'Authorization': `Bearer ${token.access_token}` }}; // All Sign In Users can use the report.
    (window['YouDJ'] && window['YouDJ'].set_reporting_token) && window['YouDJ'].set_reporting_token(token.access_token); // Report from the player
   
    /* YD API */
    const getFromYD = (path, data) => axios.post(`${Config.API_DJAPP_URL}${path}`, querystring.stringify(data), { headers: { 'content-type': 'application/x-www-form-urlencoded; charset=utf-8' } });
  
    /* LINK API */
    const customPromise = (promise) => promise.then(data => [null, data]).catch(error => [error]);
    const getFromApi = async (path, cache = true, axiosToken = null, base = Config.API_URL) => {
      const customHeaders = axiosToken ? { cancelToken: axiosToken } : {};
  
      const rcache = JSON.parse(sessionStorage.getItem(path));
      if (rcache) {
        return new Promise((resolve, reject) => {
          (rcache) ? resolve(rcache) : reject(new Error('No request cache found.'));
        });
      } else {
        const [error, result] = await customPromise(axios.get(`${base}${path}`, { ...getHeaders(), ...customHeaders }));
        if (cache && result && !error) {
          try {
            sessionStorage.setItem(path, JSON.stringify(result));
          } catch (e) {
            sessionStorage.clear();
          }
        }
        return new Promise((resolve, reject) => {
          if (result) {
            resolve(result);
          } else {
            reject(error);
            // const e = JSON.parse(JSON.stringify(error, null, 2));
            // const errorData = {
            //   url: (e.config) ? e.config.url: 'url nok',
            //   message: (e.message) ? e.message: 'message nok',
            //   res: (error.response) ? JSON.stringify(error.response.data) : 'res nok',
            //   status: (error.response) ? error.response.status: 'status nok',
            // }
            // getFromYD(`/tracking-error-api.php`, errorData);
          }
        });
      }
  
      // return axios.get(`${Config.API_URL}${path}`, { /*...headers,*/ ...getHeaders(), ...customHeaders });
    }
    const getFromApiSearch = async (path, isBaseRootApi, cache = true) => {
      return getFromApi(path, cache, null, isBaseRootApi ? Config.API_URL : Config.API_SEARCH_URL)
    }
    const getFromURL = path => axios.get(`${path}`, getHeaders());
    const getFromURI = path => axios.get(`https://${path}`, getHeaders());
    const post = (path, data, customHeaders = {}) => axios.post(`${Config.API_URL}${path}`, data, /*headers*/{ ...getHeaders(), ...customHeaders });
    const postR = (path, data) => axios.post(`${Config.API_URL}${path}`, data, headersReporting);
    const patch = (path, data) => axios.patch(`${Config.API_URL}${path}`, data, getHeaders());
    const del = (path) => axios.delete(`${Config.API_URL}${path}`, getHeaders());
    const delCustom = (path, data) => axios.request({ method: 'delete', url: `${Config.API_URL}${path}`, data, headers: {'Authorization': `Bearer ${token.access_token}`}})
    const introspect = () => axios.get(`${Config.API_URL}/v4/auth/o/introspect/`, getHeaders());
    const introspectV2 = () => axios.get(`${Config.API_URL}/v4/my/subscription-info`, getHeaders());
   
    const setDeckInfo = (_pid, audio, url, length, autoplay, start_s = null, end_s = null, isBroadcast = true) => {
      const linkTo = (audio.releaseID) ? `/releases/${audio.releaseID}/${audio.id}` : (audio.from ? audio.from : null);
      const backTo = (audio.from) ? audio.from : linkTo;
      const limitTitle = Config.limitString(`${audio.title}${(audio.mix_name !== '') ? ` - ${audio.mix_name}` : ``}`, 44);
      const title = (linkTo) ? `<div class="flexRow"><span class="song_link${_pid}" onclick="window.DJAPPMM.goLink('${backTo}', 'DI-${audio.id}-TRACK');">${limitTitle}</span><div id='deck${_pid}-actions' /></div>` : limitTitle;
      if (linkTo && Config.MOD_LINKAGE) {
        const el = document.getElementById(`image${_pid}`);
        if (el) {
          const clone = el.outerHTML;
          el.outerHTML = clone;
          document.getElementById(`image${_pid}`).style.cursor = `pointer`;
          const onClickCover = () => { window.DJAPPMM.goLink(`${linkTo}`) }
          document.getElementById(`image${_pid}`).addEventListener("click", onClickCover);
        }
      }
  
      const keys = (audio.key_camelot) ? `${audio.bpm} / ${audio.key_camelot}` : null;
      window['YouDJ'] && window['YouDJ'].loadsong(_pid, url, title, audio.tag, keys, length, audio.id, audio.img, autoplay, start_s, end_s, isBroadcast);
      setTimeout(() => { 
        const el = document.getElementById(`image${_pid}`);
        if (el) {
          el.ondragstart = function() { return false; }; // Disable Dragging
        }
        dispatch(setDragPlayer(_pid, audio));

        // Tag
        const tag = (audio.pre_order) ? 'Pre-order' : null; /*(!audio.is_available_for_streaming ? `Preview` : null )*/;
        if (tag) {
          let div = document.createElement("div");
          div.className = `tag-cover tc-${tag.toLowerCase()}`;
          let span = document.createElement("span");
          span.innerText = tag;
          span.className = `tc-span`;
          div.appendChild(span);          
          document.getElementById(`image${_pid}`).appendChild(div);
        }
      }, 500);
    }
  
    const loadAudio = (_pid, audio, autoplay, isLink = false, isBroadcast = true) => {
      if (!isLink) { //Freemium 
        if (audio.sample_url) {
          setDeckInfo(_pid, audio, audio.sample_url, audio.length_s, autoplay, audio.sample_start_ms / 1000, audio.sample_end_ms / 1000);
          dispatch(addFreemiumTracksLoad());
        } else {
          getFromApi(`/v4/catalog/tracks/${audio.id}/`, false).then( response => {
            setDeckInfo(_pid, audio, response.data.sample_url,  response.data.length_ms / 1000, autoplay,  response.data.sample_start_ms / 1000, response.data.sample_end_ms / 1000);
            dispatch(addFreemiumTracksLoad());
          }).catch( e => {
            const error = JSON.parse(JSON.stringify(e, null, 2));
            if (e.response) {
              error.extra = (e.response.data) ? e.response.data : null;
              error.status = (e.response.status) ? e.response.status : null;
            }
            dispatch(setRequestError(error));
          });
        }          
      } else {
        if (audio.forceURL) { // From Custom Playlist (Outside MP4)
          loadAudioUrl(_pid, audio, audio.forceURL)
        } else {  
          // HLS
          getFromApi(`/v4/catalog/tracks/${audio.id}/stream/`, false).then( response => {
            setDeckInfo(_pid, audio, response.data.stream_url, audio.length_s, autoplay, null, null, isBroadcast);
            if (isBroadcast) { // For no subscribers + restricted territory
              dispatch(broadcastAudioPM({
                id: audio.id,
                title: audio.name,
                mix_name: audio.mix_name,
                img: audio.img,
                key: audio.key,
                key_camelot: audio.key_camelot,
                release: audio.release,
                releaseID: audio.releaseID,
                length_s: audio.length_s,
                tag: audio.tag,
                url: response.data.stream_url,
                deck: _pid
              }))
            }
          }).catch( e => {
            const error = JSON.parse(JSON.stringify(e, null, 2));
            if (e.response) {
              error.extra = (e.response.data) ? e.response.data : null;
              error.status = (e.response.status) ? e.response.status : null;
            }

            // TEMPORARY UNTIL THE API FIX THE UNCONSISTENCY
            if (error.extra && error.extra.detail === 'Track is not available for streaming.' && audio.sample_url) {
              audio.is_available_for_streaming = false;
              dispatch(addToast({ content: <span>Download only, full-track streaming is unavailable.</span>, typeClass: 'warning', iconStyle: { padding: '32px 16px', marginRight: 16 } }));
              setDeckInfo(_pid, audio, audio.sample_url, audio.length_s, autoplay, audio.sample_start_ms / 1000, audio.sample_end_ms / 1000);
            } else {
              dispatch(setRequestError(error));
            }

          });
        }
      }
    }
    const loadAudioUrl = (_pid, audio, url) => {
      setDeckInfo(_pid, audio, url, audio.length_s, false, null, null, false);
    }
  
    const store = { token, setToken, getFromApi, getFromApiSearch, getFromURL, getFromURI, getFromYD, loadAudio, loadAudioUrl, post, postR, patch, del, delCustom, introspect, introspectV2 };
    dispatch(setAPI(store));
    return store;
  }


  const initApp = (store, isRefresh = false) => {
    const finalize = (type) => {

      if (!localStorage.getItem('fl')) {
        dispatch(setFirstLog(true));
        localStorage.setItem('fl', true);
      } else if (localStorage.getItem('fl') && localStorage.getItem('fl') === 'false') {
        localStorage.setItem('fl', true);
      }

      // dispatch(setAuthResponse(true));
      store.getFromApi(`/v4/my/account/`, false).then( res => {
        const name = res.data.username;
        const email = res.data.email;
        const firstname = res.data.first_name;
        const id = res.data.id;
        const cover = (res.data.dj_profile && res.data.dj_profile.image) ? res.data.dj_profile.image.media_url : Config.DEFAULT_AVATAR;
        const preferences_audio_format_id = (res.data.preferences && res.data.preferences.audio_format_id) ? res.data.preferences.audio_format_id : Config.CART_AUDIO_FORMAT; // Default MP3
        
        // store.getFromApi(`/v4/my/email-preferences/`, false).then( pref => {
        //   const aValids = ['opt_in_offers', 'opt_in_happenings', 'opt_in_content', 'opt_in_store', 'opt_in_stream', 'opt_in_hype', 'opt_in_beatportal', 'opt_in_loopmasters']
        //   const hasNewsletterOptIns = aValids.reduce((base, value) => (pref.data[value] === 'True') , false);
        //   dispatch(setUserParameter('hasNewsletterOptIns', hasNewsletterOptIns));
        // })        
        
        store.getFromApi(`/v4/my/genres/?per_page=50`, false)
          .then( r => { dispatch(setUser({ name, id, type, email, firstname, cover, preferences_audio_format_id, genres_ids: r.data.results.map(x => x.id), genres: r.data.results.map(x => ({id: x.id, name: x.name})) })); })
          .catch( e => { dispatch(setUser({ name, id, type, email, firstname, cover, preferences_audio_format_id, genres_ids: [], genres: [] })); })
        if (window['YouDJ'] && window['YouDJ'].login) {
          window['YouDJ'].login(res.data.id, res.data.username, cover);
        }
        if (window['YouDJ'] && window['YouDJ'].beatport_login) {
          window['YouDJ'].beatport_login(res.data.id, res.data.username, cover);
        }
  
      })
    }

    store.introspectV2().then( rInstrospect => { //LINK SUBSCRIBER
      const acronyme = Config.ACRONYME;
      const allow = [
        `${acronyme}_basic`, // ESSENTIAL
        `${acronyme}_basic_annual`, // ESSENTIAL
        `${acronyme}_link`, // ADVANCED
        `${acronyme}_link_annual`, // ADVANCED
        `${acronyme}_link_partners`, // ADVANCED
        `${acronyme}_link_pro`,
        `${acronyme}_link_pro_annual`,
        `${acronyme}_link_pro_partners`,
        `${acronyme}_link_pro_employee`,
        `${acronyme}_link_pro_plus`,
        `${acronyme}_link_pro_plus_partners`,
        `${acronyme}_link_pro_plus_employee`,
        `${acronyme}_link_pro_plus_ambassador`,        
        `${acronyme}_link_pro_plus_annual`,
        `${acronyme}_link_pro_plus_2`,
        `${acronyme}_link_pro_plus_2_annual`,
        `${acronyme}_link_pro_plus_2_partners`,
        `${acronyme}_link_employee`
      ]
      const isSubscribed = allow.includes(rInstrospect.data.subscription_code); //subscription
      if (Config.FREEMIUM || isSubscribed) {
        dispatch(setSubscription(isSubscribed));
        dispatch(setConnect(true));
        dispatch(setOutsiderPM(false));
        finalize(rInstrospect.data.subscription_code);
        const isProPlus = rInstrospect.data.subscription_code ? rInstrospect.data.subscription_code.includes(`link_pro_plus`) : false;
        dispatch(setProPlus(isProPlus));
      } else {
        dispatch(setSubscription(false));
        dispatch(setConnect(false));
        dispatch(setOutsiderPM(false));
        // dispatch(setAuthResponse(`no-link`));
      }

      dispatch(setSplashState(false)); // PLAYER + LIBRARY -> READY

    })
  }


  return { prepareStore, initApp };
};

export default useStoreApi;
